module.exports = __webpack_public_path__ + "static/media/logo.073eecbe.png";